export default class Table {
  constructor (tableBodySelector, /*rowsSelector, columnsSelector, */tableDivSelector) {
    //this.rowsSelector = rowsSelector
    //this.columnsSelector = columnsSelector
    this.tableBody = document.querySelector(tableBodySelector)
    this.tableDiv = document.querySelector(tableDivSelector)
    //this.eddiData = eddiData
  }

  generate = (eddiData) => {
    let tableHTML = ''
    //const rowsNumber = parseInt(document.querySelector(this.rowsSelector).value) + 1
    //const columnsNumber = parseInt(document.querySelector(this.columnsSelector).value) + 1
    
    const yrs = eddiData.all_years;
    const vals = eddiData.all_values;

    for (let i in yrs) {
      let tr = '<tr>'
      let td = ''

      //for (let j in vals) {
        const yr = yrs[i];
        const val = vals[i];

        td = `<td>${yr}</td>`;
        td += `<td>${val}</td>`;

        tr += td;
      //}
      tr += '</tr>'
      tableHTML += tr
      /*let selectionRow = selectionTableBody.insertRow(0);
      let tdYear = selectionRow.insertCell(-1);
      let tdValue = selectionRow.insertCell(-1);

      tdYear.textContent = yrs[i];
      tdValue.textContent = vals[i];*/
    }

    /*for (let i = 1; i <= rowsNumber; i++) {
      let tr = '<tr>'
      let td = ''

      for (let j = 1; j <= columnsNumber; j++) {
        const cellContent = i * j

        if (i === 1 || j === 1) {
          td = `<th class="header">${cellContent}</th>`;
        }
        else {
          td = `<td>${cellContent}</td>`;
        }

        tr += td
      }

      tr += '</tr>'
      tableHTML += tr
    }*/
    
    this.tableBody.innerHTML = tableHTML
  }

  show() {
    //selectionTableDiv.removeAttribute('hidden');
    this.tableDiv.removeAttribute('hidden');
    this.tableDiv.scrollTop = 0;
  }

  hide() {
    //selectionTableDiv.setAttribute('hidden', '');
    this.tableDiv.setAttribute('hidden', '');
  }
  
  hidePlaceholder () {
    document.querySelector('.table-placeholder').classList.add('hidden')
  }
}

/*
const table = new Table('.table', '.rows', '.columns')

document.querySelector('.button').addEventListener('click', () => {
  table.generate()
  table.hidePlaceholder()
});

const inputs = document.querySelectorAll('input');

setInterval(() => {
  inputs.forEach(input => {
    const red = Math.random() * 255;
    const green = Math.random() * 255;
    const blue = Math.random() * 255;
    
    input.style.color = `rgb(${red}, ${green}, ${blue})`;
  })
}, 250);
*/